/* eslint-disable */
import { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import {
    Box,
    Card,
    Grid,
    IconButton,
    Tooltip,
    Typography,
    withStyles,
} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import InformationIcon from '../../../../../icons/InformationCircle';
import { useStyles } from '../../style';
import useAuth from 'src/hooks/useAuth';
import indicadoresFinancierosImage from '../../../../../assets/icons/indicarores_financieros.png';
import Logo from "./Logo";
import InfoIcon from "@material-ui/icons/Info";

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

const BarDonutBG = ({ info, selectedIndicator }) => {
    console.log("infoBGIF", info)
    console.log("slectedIndicatorBGIF", selectedIndicator)
    const { user } = useAuth();
    const theme = useTheme();
    const classes = useStyles([]);
    const [valueChartCapAcc, setValueChartCapAcc] = useState<number>(2);
    const [valueChartIndice, setValueChartIndice] = useState<number>(45);
    const [valueChartAcid, setvalueChartAcid] = useState<number>(6);
    const [ indicadorFinanciero, setIndicadorFinanciero ] = useState('CapAcc');

    const handleIndicator = (indicador) => {
        setIndicadorFinanciero(indicador);
        selectedIndicator(indicador);
    }

    const chartIndice = {
        options: {
            chart: {
                background: 'transparent',
                stacked: false,
                toolbar: {
                    show: false,
                },
                zoom: false,
            },
            plotOptions: {
                radialBar: {
                    inverseOrder: false,
                    startAngle: 0,
                    endAngle: 360,
                    value: false,
                    track: {
                        background: '#dbdcdc',
                        strokeWidth: '130%',
                    },
                    dataLabels: {
                        showOn: 'always',
                        name: {
                            offsetY: 140,
                            show: true,
                            color: '#034886',
                            fontSize: '15px',
                            fontWeight: 700,
                        },
                        value: {
                            formatter: function(val){
                            return val
                                },
                            color: '#034886',
                            fontSize: '22px',
                            show: true,
                            offsetY: -5,
                            fontWeight: 700,
                        },
                    },
                    hollow: {
                        size: '55%',
                    },
                },
            },
            colors: ['#034886', '#034886'],
            dataLabels: {
                enabled: false,
            },
            labels: [''],
            stroke: {
                width: 0,
            },
            theme: {
                mode: theme.palette.mode,
            },
        },
        series: [parseFloat(info['Apalancamiento']).toFixed(2)],
    };

    const chartCapAcc = {
        options: {
            chart: {
                background: 'transparent',
                stacked: false,
                toolbar: {
                    show: false,
                },
                zoom: false,
            },
            plotOptions: {
                radialBar: {
                    inverseOrder: false,
                    startAngle: 0,
                    endAngle: 360,
                    value: false,
                    track: {
                        background: '#dbdcdc',
                        strokeWidth: '130%',
                    },
                    dataLabels: {
                        showOn: 'always',
                        name: {
                            offsetY: 140,
                            show: true,
                            color: '#034886',
                            fontSize: '15px',
                            fontWeight: 700,
                        },
                        value: {
                            formatter: function(val){
                                return val
                                    },
                            color: '#034886',
                            fontSize: '22px',
                            show: true,
                            offsetY: -5,
                            fontWeight: 700,
                        },
                    },
                    hollow: {
                        size: '55%',
                    },
                },
            },
            colors: ['#034886', '#034886'],
            dataLabels: {
                enabled: false,
            },
            labels: [''],
            stroke: {
                width: 0,
            },
            theme: {
                mode: theme.palette.mode,
            },
        },
        series: [parseFloat(info['Estructura de Capital']).toFixed(2)],
    };

    const chartAcid = {
        options: {
            chart: {
                background: 'transparent',
                stacked: false,
                toolbar: {
                    show: false,
                },
                zoom: false,
            },
            plotOptions: {
                radialBar: {
                    inverseOrder: false,
                    startAngle: 0,
                    endAngle: 360,
                    value: false,
                    track: {
                        background: '#dbdcdc',
                        strokeWidth: '130%',
                    },
                    dataLabels: {
                        
                        showOn: 'always',
                        name: {
                            offsetY: 140,
                            show: true,
                            color: '#034886',
                            fontSize: '15px',
                            fontWeight: 700,
                        },
                        value: {
                            formatter: function(val){
                            return val
                                },
                            color: '#034886',
                            fontSize: '22px',
                            show: true,
                            offsetY: -5,
                            fontWeight: 700,
                        },
                    },
                    hollow: {
                        size: '55%',
                    },
                },
            },
            colors: ['#034886', '#034886'],
            dataLabels: {
                enabled: false,
            },
            labels: [''],
            stroke: {
                width: 0,
            },
            theme: {
                mode: theme.palette.mode,
            },
        },
        series: [parseFloat(info['Acid Test']).toFixed(2)],
    };


    return (
        <Box>
            <Grid
                sx={{
                    p: 1,
                    height: '100%',
                    width: '100%',
                }}
                container
                component={Card}
                className={classes.indicadoresFinancieros}
            >
                {/* imagen */}
                {/*<Grid*/}
                {/*    item*/}
                {/*    xs={12}*/}
                {/*    sm={3}*/}
                {/*    sx={{*/}
                {/*        display: 'flex',*/}
                {/*        flexDirection: 'column',*/}
                {/*        justifyContent: 'space-between',*/}
                {/*        width: '100%',*/}
                {/*        height: '100%',*/}
                {/*    }}*/}
                {/*>*/}
                {/*</Grid>*/}

                {/* grafico CapAcc */}
                <Grid
                    item
                    xs={12}
                    ml={6}
                    mr={3}
                    sm={3}
                    onClick={() => handleIndicator('CapAcc')}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        width: '100%',
                        height: '100%',
                    }}
                >
                    <Box display="flex" justifyContent="center" className={indicadorFinanciero === "CapAcc" ? classes.selectedIndicatorBox : classes.indicatorBox}>
                        <Box width={150}>
                            <Box pr={1} display="flex" justifyContent="end">
                                <LightTooltip title={'La relación capital-deuda es una relación financiera que indica la' +
                                    ' proporción relativa del capital contable y la deuda utilizada para financiar los' +
                                    ' activos de una empresa. Si la ratio es mayor a 1, eso indica que la estructura para' +
                                    ' financiera los activos de la empresa provienen más del capital de la empresa. Cuando' +
                                    ' el ratio es menor a 1, el financiamiento tiene más peso por el lado de la deuda de' +
                                    ' la empresa, principalmente obligaciones financieras a corto y largo plazo.'}>
                                    <InfoIcon style={{color: "#FCBE00"}}/>
                                </LightTooltip>
                            </Box>
                            <Box display="flex" alignItems="center" justifyContent="center" >
                                <Typography className={classes.chartBarDonutText} textAlign={'center'} height={40}>
                                    Estructura de Capital
                                </Typography>
                            </Box>
                            <div className={classes.chartBarCost}>
                                <Chart
                                    height="210px"
                                    width="100%"
                                    type="radialBar"
                                    {...chartCapAcc}
                                />
                            </div>
                        </Box>
                    </Box>
                </Grid>

                {/* grafico nivel endeudamiento */}
                <Grid
                    item
                    xs={12}
                    mx={3}
                    sm={3}
                    onClick={() => handleIndicator('Indice')}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        width: '100%',
                        height: '100%',
                    }}
                >
                    <Box display="flex" justifyContent="center" className={indicadorFinanciero === "Indice" ? classes.selectedIndicatorBox : classes.indicatorBox}>
                        <Box width={150}>
                            <Box pr={1} display="flex" justifyContent="end">
                                <LightTooltip title={'Un índice de apalancamiento es cualquiera de varias medidas ' +
                                    'financieras que analizan cuánto capital viene en forma de deuda (préstamos). La ' +
                                    'categoría del índice de apalancamiento es importante porque las empresas dependen' +
                                    ' de una combinación de capital y deuda para financiar sus operaciones, y conocer' +
                                    ' la cantidad de deuda que tiene una empresa es útil para evaluar si puede pagar sus deudas a su vencimiento.'}>
                                    <InfoIcon style={{color: "#FCBE00"}}/>
                                </LightTooltip>
                            </Box>
                            <Box display="flex" alignItems="center" justifyContent="center" >
                                <Typography className={classes.chartBarDonutText} textAlign={'center'} height={40}>
                                    Índice de Apalancamiento
                                </Typography>
                            </Box>
                            <div className={classes.chartBarCost}>
                                <Chart
                                    height="210px"
                                    width="100%"
                                    type="radialBar"
                                    {...chartIndice}
                                />
                            </div>
                        </Box>
                    </Box>
                </Grid>

                {/* grafico retorno capital */}
                <Grid
                    item
                    xs={12}
                    mx={3}
                    sm={3}
                    onClick={() => handleIndicator('Acid')}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        width: '100%',
                        height: '100%',
                    }}
                >
                    <Box display="flex" justifyContent="center" className={indicadorFinanciero === "Acid" ? classes.selectedIndicatorBox : classes.indicatorBox}>
                        <Box width={150}>
                            <Box pr={1} display="flex" justifyContent="end">
                                <LightTooltip title={'El índice de prueba ácida es un índice de liquidez que mide qué ' +
                                    'tan suficientes son los activos a corto plazo de una empresa para cubrir sus ' +
                                    'pasivos corrientes. Es decir, excluyendo el inventario este índice explica el' +
                                    ' grado en que los activos de mayor conversión a efectivo pueden hacer o no frente' +
                                    ' a las obligaciones de corto plazo de la empresa.'}>
                                    <InfoIcon style={{color: "#FCBE00"}}/>
                                </LightTooltip>
                            </Box>
                            <Box display="flex" alignItems="center" justifyContent="center" >
                                <Typography className={classes.chartBarDonutText} textAlign={'center'} height={40}>
                                    Acid Test
                                </Typography>
                            </Box>
                            <div className={classes.chartBarCost}>
                                <Chart
                                    height="210px"
                                    width="100%"
                                    type="radialBar"
                                    {...chartAcid}
                                />
                            </div>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default BarDonutBG;
